import { Icon, Typography } from '@/components/common';
import clsx from 'clsx';
import * as React from 'react';

interface ContentCardProps {
	title: string;
	children: React.ReactNode;
	icon: string;
	classNameItemIcon?: string;
	customButton?: React.ReactNode;
	classNameContainer?: string;
}

export const ContentCard: React.FC<ContentCardProps> = ({
	title,
	children,
	icon,
	classNameItemIcon,
	customButton,
	classNameContainer,
}) => {
	return (
		<div
			className={clsx(
				'bg-bg-white py-4 px-[23px] rounded-2xl lg:max-w-[756px]',
				classNameContainer
			)}
		>
			<div className="flex items-center justify-between gap-x-2">
				<div className="flex items-center gap-x-2.5">
					<span className="flex items-center justify-center bg-white size-10 rounded-lg">
						<Icon src={icon} className={clsx('!size-5', classNameItemIcon)} />
					</span>
					<Typography type="semibold-14" className="text-black">
						{title}
					</Typography>
				</div>
				{customButton && customButton}
			</div>
			{children}
		</div>
	);
};
